import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/totalIronBindingCapacity";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	totalIronBindingCapacity: {
		id: "ktx.totalIronBindingCapacity.title",
		defaultMessage: "TVK"
	},
	value: {
		id: "ktx.totalIronBindingCapacity.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_totalIronBindingCapacity",
	value: {
		schemaId: "totalIronBindingCapacity",
		title: messages.totalIronBindingCapacity,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
